import Vue from 'vue';
import accountService from './index';

const success = (context) => {
  accountService.getPromoCodes(context);
  toastr.success(context.$t('booking.promo.added'));
};

const failed = (error, context) => {
  context.showToasterError(error);
};

export default (context, data) => {
  return Vue.$http.post('/promo-code', data).then((response) => {
    if (response && response.status === 200) {
      success(context);
    }
  })
    .catch((error) => {
      failed(error, context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/account/createPromoCode.js